export default __webpack_public_path__ + "static/media/sms-topup.79f77110.png";